export enum PriceSortOption {
  HIGH_TO_LOW = 'HIGH_TO_LOW_PRICE',
  LOW_TO_HIGH = 'LOW_TO_HIGH_PRICE',
}
